import React, { useEffect, useState } from "react";
import { Col, Form, Row, Tab, Tabs, Modal, DropdownButton, ButtonGroup, Dropdown } from "react-bootstrap";
import toast from "react-hot-toast";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import Delete from "../../../Components/Modals/DeleteModal";
import Navbar from "../../../Components/Navbar/Navbar";
import Table from "../../../Components/TableTemplate/Table";
import AdjustmentTable from "./../../Inventory/Adjustment/AdjustmentTable";
import NoDataImg from "../../../Assets/Images/no-data-img.png"
import {
    dateFormat,
    formatDateNoTime,
    formatDate,
    numberFormat,
    refreshPage,
    toastStyle,
    getTodayDate,
    getType,
    TokenExpiry,
    getTodayDateISO,
    selectDropdownStyle
} from "../../../Helpers/Utils/Common"; 
import DatePicker from "react-datepicker";
import Moment from "moment";

import { getAllBanks } from "../../../Helpers/apiCalls/banksAPi";
import { getAllFranchisee } from "../../../Helpers/apiCalls/franchiseeApi";
import { searchStoreDeposit, updateStatusStoreDeposit, deleteStoreDeposit } from "../../../Helpers/apiCalls/Reports/StoreDepositApi";
import { getCashCountReport } from "../../../Helpers/apiCalls/Reports/DailyCashCountApi";
// import { getAllBranches } from "../../../Helpers/apiCalls/Manage/Branches";
import { getAllEmployees } from "../../../Helpers/apiCalls/employeesApi";
import { CSVLink, CSVDownload } from "react-csv";
import downloadIcon from "../../../Assets/Images/download_icon.png";
import { Fragment } from "react";
import { getAllDiscounts, getAllDiscountsPotato, deleteDiscounts, deleteDiscountsPotato } from './../../../Helpers/apiCalls/Manage/DiscountsApi';
import { searchBranch } from './../../../Helpers/apiCalls/Manage/Branches';
import { searchBranchPotato } from './../../../Helpers/apiCalls/PotatoCorner/Manage/Branches';
import { getCategory } from "../../../Helpers/apiCalls/categoryApi";
import { searchItem } from "../../../Helpers/apiCalls/itemsApi";
import Footer from "../../../Components/Footer/Footer";


export default function Payroll() {
    let navigate = useNavigate();
    var dateToday = getTodayDate();
    const accountType = getType();
    const [inactive, setInactive] = useState(true);
    const [filterConfig, setFilterConfig] = useState({
        tab: "valid",
        validity: "valid",
        branch_id: "",
        code: "",
        date_from: "",
        date_to: "",
    })
    const [employees, setEmployees] = useState([]);
    const [isClicked, setIsClicked] = useState(false);
    const [showLoader, setShowLoader] = useState(false);
    const [showDetails, setShowDetails] = useState(false);
    const [discounts, setDiscounts] = useState([]);
    const [totalSales, setTotalSales] = useState([]);
    const [checkedPayments, setCheckedPayments] = useState([]);
    const [selectedTab, setSelectedTab] = useState("submitted");
    const [dailySales, setDailySales] = useState([]);
    const [branches, setBranches] = useState([]);
    const [categories, setCategories] = useState([]);
    const [items, setItems] = useState([]);

     /* delete modal handler */
     const [showDeleteModal, setShowDeleteModal] = useState(false);
     const handleShowDeleteModal = () => setShowDeleteModal(true);
     const handleCloseDeleteModal = () => setShowDeleteModal(false); 

     const [selectedRow, setSelectedRow] = useState([]);
     const [selectedEmployee, setSelectedEmployee] = useState([]);
     const today = Moment().format("MM/DD/YYYY");

    const excelHeaders = [
        // { label: "Sales Date", key: "sales_date" },
        { label: "Total Sales", key: "total_sales" },
        { label: "Branch Name", key: "branch_name" },
        { label: "Bank", key: "bank" },
        // { label: "DSR No.", key: "dsr_no" },
        { label: "Deposit Date", key: "deposited_on" },
        { label: "Transaction Type", key: "transaction_type" },
        // { label: "Deposited By", key: "deposited_by" },
    ];

    const dummy = [
        {
            id: "1",
            type: "mango",
            branch_name: "SM CITY CEBU",
            date: "December 2022",
            amount: "1000",
            added_by: "JOSE RIZAL",
        },
        {
            id: "2",
            type: "potato",
            branch_name: "SM CONSOLACION",
            date: "December 2022",
            amount: "1000",
            added_by: "JOSE RIZAL",
        },
    ]

    const handleTabSelect = (key) => {
        setFilterConfig((prev) => {
            return {
                ...prev,
                tab: key,
                validity: key,
            };
        });
    };

    // SEARCH USER
    function handleOnSearch(e) {
        const { name, value } = e.target;
        setFilterConfig((prev) => {
            return { ...prev, [name]: value };
        });
    }

    function handleSelectChange(e, row) {
        setSelectedRow(row);
        

        if (e.target.value === "view") {
            navigate("/discounts/view/" + row.type + "/" + row.id)
        } else if (e.target.value === "edit") {
            navigate("/discounts/edit/" + row.type + "/" + row.id)
        } else if (e.target.value === "delete") {
            handleShowDeleteModal();
        }
    }


    function ActionBtn(row, type) {
        return (
            <Form.Select
                name="action"
                className="PO-select-action"
                onChange={(e) => handleSelectChange(e, row)}
            >
                <option value="" hidden selected>
                    Select
                </option>
                <option value="view" className="color-options">
                    View
                </option>
                <option value="edit" className="color-options">
                    Edit
                </option>
                <option value="delete" className="color-red">
                    Delete
                </option>
            </Form.Select>
        );
    }

    function ViewBtn(row) {
        return (
            <button
                name="action"
                className="btn btn-sm view-btn-table"
                id={row.id}
                onClick={() => navigate("/discounts/view/" + row.type + "/" + row.id)}
            >
                View
            </button>
        );
    }

    async function fetchEmployees() {

        const response = await getAllEmployees();
        if (response.error) {
            setEmployees([])
        } else {
            let result = response.data.data.map((data) => {
                var employee = data;
                employee.label = data.first_name + " " + data.last_name;
                employee.value = data.id;
                return employee;
            });
            setEmployees([{label: "All Employees", value:""}, ...result]);
        }
    }

    async function fetchBranches() {
        setBranches([]);
        const response = await searchBranch({is_franchise: 0});
        if (response.data) {
            var result = response.data.data.map((data) => {
                var branch = data;
                branch.label = data.name;
                branch.value = data.id;
                setBranches((prev) => [...prev, branch]);
            });
        }
    }

    async function fetchData() {
        setShowLoader(true);
        setDiscounts([])

        const response = await getAllDiscounts(filterConfig);
        
        if (response.error) {
            setDiscounts([])
        } else {
            var allData = response.data.data.map((data) => {
                var days = ""
                if(data.sundays === "1") {
                    days = "Sunday "
                }
                if(data.mondays === "1") {
                    days = days + "Monday "
                }
                if(data.tuesdays === "1") {
                    days = days + "Tuesday "
                }
                if(data.wednesdays === "1") {
                    days = days + "Wednesday "
                }
                if(data.thursdays === "1") {
                    days = days + "Thursday "
                }
                if(data.fridays === "1") {
                    days = days + "Friday "
                }
                if(data.saturdays === "1") {
                    days = days + "Saturday "
                }
                
                var info = data;
                info.added_on = Moment(data.added_on).format("MM/DD/YYYY")
                info.valid_date = formatDate(data.valid_from) + " - " + formatDate(data.valid_to)
                info.applicable_days = days
                info.commission_rate = numberFormat(data.commission_rate)
                info.vat_rate = numberFormat(data.vat_rate)
                info.other_fee = numberFormat(data.other_fee)
                info.discount_amount = numberFormat(data.discount_amount)
                return info;
            });
            setDiscounts(allData)
        }
        setShowLoader(false);
    }

    async function handleDeleteDiscount() {
        setIsClicked(true);
        
        const response = await deleteDiscounts(selectedRow.id);
        if (response.data) {
            toast.success(response.data.message, {
                style: toastStyle(),
            });
            setTimeout(() => refreshPage(), 1000);
        } else {
            response.error?.response?.data?.messages.map((data) => {
                return toast.error(data);
            })
        }
        
    }

    function handleAddChange(e) {
        navigate("/discounts/add/" + e.target.value);
    }

    async function fetchCategories() {
        setCategories([]);

        const response = await getCategory({});
        if (response.data) {
        //categories
        var categories = response.data.data.map((category) => {
            var info = {}
            info.name = "category"
            info.value = category.id
            info.label = category.name
            info.id = category.id
            info.selected_value_name = "selected_category"
            return info
        })
        setCategories(categories);
        }
    }

    async function fetchItems() {
        setItems([]);
        const response = await searchItem({});
        if (response.response) {
        //categories
        var items = response.response.data.map((item) => {
            var info = {}
            info.name = "item"
            info.value = item.id
            info.label = item.name
            info.id = item.id
            info.selected_value_name = "selected_item"
            return info
        })
        setItems(items);
        }
    }


    useEffect(() => {
        fetchEmployees();
        fetchCategories();
        fetchItems();
        fetchBranches();
    }, []);

    useEffect(() => {
        fetchData();
    }, [filterConfig]);

    return (
        <div>
            <div className="page">
                <Navbar
                    onCollapse={(inactive) => {
                        setInactive(inactive);
                    }}
                    active={"MANAGE ITEM"}
                />
            </div>

            <div
                className={`manager-container ${
                    inactive ? "inactive" : "active"
                }`}
            >
                {/* headers */}
                <Row className="mb-4">
                    <Col xs={12} lg={7}>
                        <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2"> ITEM DISCOUNTS </h1>
                    </Col>
                    <Col xs={12} lg={3} className="d-flex justify-content-end force-width flex-column flex-lg-row gap-3">
                        <input
                            name="anything"
                            placeholder="Search..."
                            className="search-bar"
                            // onChange={handleOnSearch}
                            onKeyPress={(e) =>
                                e.key === ("Enter" || "NumpadEnter") &&
                                handleOnSearch(e)
                            }
                        />
                    </Col>
                    <Col lg={2} className="mt-2 mt-lg-0">
                        <div className="PO-filters">
                            <Form.Select
                                // className="add-select"
                                className="date-filter force-width w-full"
                                style={{ backgroundColor: "var(--primary-color)", color: "white"}}
                                onChange={(e) => handleAddChange(e)}
                            >
                                <option value="" hidden selected>
                                    Add
                                </option>
                                <option value="item">Item</option>
                                <option value="category">Category</option>
                            </Form.Select>
                        </div>
                    </Col>
                </Row>

                <Tabs
                    activeKey={filterConfig.tab}
                    // defaultActiveKey={filterConfig.shop}
                    id="PO-tabs"
                    className="manager-tabs"
                    onSelect={handleTabSelect}
                >
                    <Tab eventKey="valid" title="active">

                        <div className="tab-content">
                            {/* filters */}
                            <div className="mb-3" />
                            <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
                                Filter By:
                            </span>
                            <Row className="PO-filters flex flex-row mx-2 my-1">
                                <Col xs={6} lg={3} className="mb-2 mb-lg-0">
                                <Select
                                    className="dropsearch-filter px-0 py-0 me-2"
                                    classNamePrefix="react-select"
                                    placeholder="Select item"
                                    styles={selectDropdownStyle}
                                    value={filterConfig.selected_item}
                                    options={[{label: "All Items", value: ""}, ...items]}
                                    onChange={(e) => { setFilterConfig((prev) => {
                                        return { ...prev, 
                                                "item_id": e.value,
                                                "selected_item": {
                                                value: e.value,
                                                label: e.label 
                                                }
                                            };
                                    });}}
                                />
                                </Col>
                                <Col xs={6} lg={2} className="mb-2 mb-lg-0">
                                <Select
                                    className="dropsearch-filter px-0 py-0 me-2"
                                    classNamePrefix="react-select"
                                    placeholder="Select Branch"
                                    styles={selectDropdownStyle}
                                    value={filterConfig.selected_branch}
                                    options={branches}
                                    onChange={(e) => { setFilterConfig((prev) => {
                                            return {
                                                ...prev,
                                                "branch_id": e.value,
                                                "selected_branch": {
                                                    value: e.value,
                                                    label: e.label 
                                                }
                                             };
                                        });}}
                                />
                                </Col>
                                <Col xs={12} lg={2} className="mb-2 mb-lg-0">
                                <Select
                                    className="dropsearch-filter px-0 py-0 me-2"
                                    classNamePrefix="react-select"
                                    placeholder="Select Category"
                                    styles={selectDropdownStyle}
                                    value={filterConfig.selected_category}
                                    options={[{label: "All Categories", value: ""}, ...categories]}
                                    onChange={(e) => { setFilterConfig((prev) => {
                                        return { ...prev, 
                                                "category_id": e.value,
                                                "selected_category": {
                                                value: e.value,
                                                label: e.label 
                                                }
                                            };
                                    });}}
                                />
                                </Col>
                                <Col xs={6} lg={2}>
                                <DatePicker
                                    autoComplete="off"
                                    selected={filterConfig.date_from}
                                    name="date_from"
                                    placeholderText={"Select Date"}
                                    onChange={(date) => {
                                        setFilterConfig((prev) => {
                                            return { ...prev, date_from: date };
                                        });
                                    }}
                                    fixedHeight
                                    className="date-filter me-4 form-control"
                                    showYearDropdown
                                    dateFormatCalendar="MMMM"
                                    yearDropdownItemNumber={20}
                                    scrollableYearDropdown
                                />
                                </Col>
                                <Col xs={6} lg={2}>
                                <DatePicker
                                    autoComplete="off"
                                    selected={filterConfig.date_to}
                                    name="date_to"
                                    placeholderText={"Select Date"}
                                    onChange={(date) => {
                                        setFilterConfig((prev) => {
                                            return { ...prev, date_to: date };
                                        });
                                    }}
                                    fixedHeight
                                    className="date-filter ps-label-content me-5 form-control"
                                    showYearDropdown
                                    dateFormatCalendar="MMMM"
                                    yearDropdownItemNumber={20}
                                    scrollableYearDropdown
                                />
                                </Col>
                            </Row>
                            <div className="mb-2" />
                            <div className="below">
                                {/* table */}
                                <Table
                                    tableHeaders={[
                                        "-",
                                        "ITEM NAME",
                                        "STATUS",
                                        "DISCOUNT VALUE",
                                        "BRANCH",
                                        "VALID DATE",
                                        "ACTIONS",
                                    ]}
                                    headerSelector={[
                                        "-",
                                        "item_name",
                                        "status",
                                        "discount_amount",
                                        "applicable_branches",
                                        "valid_date",
                                    ]}
                                    tableData={discounts}
                                    ActionBtn={(row) => ActionBtn(row)}
                                    ViewBtn={(row) => ViewBtn(row)}
                                    showLoader={showLoader}
                                />
                            </div>
                            <div className="mb-2" />
                        </div>
                    </Tab>
                    <Tab eventKey="invalid" title="inactive">

                        <div className="tab-content">
                            {/* filters */}
                            <div className="mb-3" />
                            <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
                                Filter By:
                            </span>
                            <Row className="PO-filters flex flex-row mx-2 my-1">
                                <Col xs={6} lg={3} className="mb-2 mb-lg-0">
                                <Select
                                    className="dropsearch-filter px-0 py-0 me-2"
                                    classNamePrefix="react-select"
                                    placeholder="Select item"
                                    styles={selectDropdownStyle}
                                    value={filterConfig.selected_item}
                                    options={[{label: "All Items", value: ""}, ...items]}
                                    onChange={(e) => { setFilterConfig((prev) => {
                                        return { ...prev, 
                                                "item_id": e.value,
                                                "selected_item": {
                                                value: e.value,
                                                label: e.label 
                                                }
                                            };
                                    });}}
                                />
                                </Col>
                                <Col xs={6} lg={2} className="mb-2 mb-lg-0">
                                <Select
                                    className="dropsearch-filter px-0 py-0 me-2"
                                    classNamePrefix="react-select"
                                    placeholder="Select Branch"
                                    styles={selectDropdownStyle}
                                    value={filterConfig.selected_branch}
                                    options={branches}
                                    onChange={(e) => { setFilterConfig((prev) => {
                                            return {
                                                ...prev,
                                                "branch_id": e.value,
                                                "selected_branch": {
                                                    value: e.value,
                                                    label: e.label 
                                                }
                                             };
                                        });}}
                                />
                                </Col>
                                <Col xs={12} lg={2} className="mb-2 mb-lg-0">
                                <Select
                                    className="dropsearch-filter px-0 py-0 me-2"
                                    classNamePrefix="react-select"
                                    placeholder="Select Category"
                                    styles={selectDropdownStyle}
                                    value={filterConfig.selected_category}
                                    options={[{label: "All Categories", value: ""}, ...categories]}
                                    onChange={(e) => { setFilterConfig((prev) => {
                                        return { ...prev, 
                                                "category_id": e.value,
                                                "selected_category": {
                                                value: e.value,
                                                label: e.label 
                                                }
                                            };
                                    });}}
                                />
                                </Col>
                                <Col xs={6} lg={2}>
                                <DatePicker
                                    autoComplete="off"
                                    selected={filterConfig.date_from}
                                    name="date_from"
                                    placeholderText={"Select Date"}
                                    onChange={(date) => {
                                        setFilterConfig((prev) => {
                                            return { ...prev, date_from: date };
                                        });
                                    }}
                                    fixedHeight
                                    className="date-filter me-4 form-control"
                                    showYearDropdown
                                    dateFormatCalendar="MMMM"
                                    yearDropdownItemNumber={20}
                                    scrollableYearDropdown
                                />
                                </Col>
                                <Col xs={6} lg={2}>
                                <DatePicker
                                    autoComplete="off"
                                    selected={filterConfig.date_to}
                                    name="date_to"
                                    placeholderText={"Select Date"}
                                    onChange={(date) => {
                                        setFilterConfig((prev) => {
                                            return { ...prev, date_to: date };
                                        });
                                    }}
                                    fixedHeight
                                    className="date-filter ps-label-content me-5 form-control"
                                    showYearDropdown
                                    dateFormatCalendar="MMMM"
                                    yearDropdownItemNumber={20}
                                    scrollableYearDropdown
                                />
                                </Col>
                            </Row>
                            <div className="mb-2" />
                            <div className="below">
                                {/* table */}
                                <Table
                                    tableHeaders={[
                                        "-",
                                        "ITEM NAME",
                                        "STATUS",
                                        "DISCOUNT VALUE",
                                        "BRANCH",
                                        "VALID DATE",
                                        "ACTIONS",
                                    ]}
                                    headerSelector={[
                                        "-",
                                        "item_name",
                                        "status",
                                        "discount_amount",
                                        "applicable_branches",
                                        "valid_date",
                                    ]}
                                    tableData={discounts}
                                    ActionBtn={(row) => ActionBtn(row)}
                                    ViewBtn={(row) => ViewBtn(row)}
                                    showLoader={showLoader}
                                />
                            </div>
                            <div className="mb-2" />
                        </div>
                    </Tab>
                </Tabs>
            </div>

            {/* modals */}
            <Delete
                show={showDeleteModal}
                onHide={handleCloseDeleteModal}
                text="discount"
                onDelete={handleDeleteDiscount}
                isClicked={isClicked}
            />

            <Footer/>
        </div>
    );
}
